import { Box, IconButton, Image } from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';
import { XIcon } from '@/imports/ui/chakra/feather';

export const ImageUploadPreviewItem: React.FC<{
  resource: { imageId: string } | { videoId: string };
  onClick: (resource: { imageId: string } | { videoId: string }) => void;
  url?: string;
}> = (props) => {
  return (
    <Box pos="relative">
      <Image
        h={24}
        w="full"
        borderRadius="base"
        objectFit="cover"
        src={props.url}
        fallback={<ImageFallback w="full" h="96px" borderRadius="base" />}
        alt=""
      />
      <IconButton
        size="xs"
        variant="outline"
        colorScheme="gray"
        borderRadius="full"
        pos="absolute"
        top={1}
        right={1}
        icon={<XIcon />}
        aria-label="Remove Image"
        onClick={() => props.onClick(props.resource)}
      />
    </Box>
  );
};
